import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { EmptyState, ErrorState, Skeleton, PageHeader } from '../../shared-ui/States';
import '../../shared-ui/crane-tokens.css';

const MAINT_API = process.env.REACT_APP_MAINTENANCE_API_URL || 'http://localhost:3010/api';
const ZMAINT_ADMIN = process.env.REACT_APP_ZMAINTENANCE_URL || 'http://localhost:3200';

/**
 * Maintenance reports live in ZTask Reports (not a duplicate nav in ZMaintenance admin).
 */
export default function MaintenanceReportsPage() {
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    setError('');
    const token = localStorage.getItem('zTaskAuthToken') || '';
    fetch(`${MAINT_API}/master-tickets`, {
      headers: {
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
        const list = Array.isArray(data) ? data : data?.data || [];
        const byStatus = list.reduce((acc, t) => {
          const s = (t.status || 'unknown').toLowerCase();
          acc[s] = (acc[s] || 0) + 1;
          return acc;
        }, {});
        setSummary({ total: list.length, byStatus });
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="crane-page">
      <PageHeader
        crumbs={['Operations', 'Reports', 'Maintenance']}
        title="Maintenance reports"
        description="Ticket summaries from the shared maintenance API."
      />
      <p style={{ marginTop: 0, color: 'var(--crane-on-surface-variant)', fontSize: 13 }}>
        Day-to-day dispatch:{' '}
        <a href={ZMAINT_ADMIN} target="_blank" rel="noreferrer">
          ZMaintenance admin
        </a>
        .
      </p>
      <p>
        <Link to="/reports">← All reports</Link>
      </p>
      {loading && <Skeleton rows={4} height={48} />}
      {!loading && error && (
        <ErrorState
          title="Could not load tickets"
          description={`${error}. Is maintenance-backend running on :3010?`}
          onRetry={load}
        />
      )}
      {!loading && !error && summary && summary.total === 0 && (
        <EmptyState title="No maintenance tickets" description="Ticket KPIs will appear when records exist." />
      )}
      {!loading && !error && summary && summary.total > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '1rem' }}>
          <div className="crane-card" style={{ padding: '1rem' }}>
            <div style={{ color: 'var(--crane-on-surface-variant)', fontSize: 13 }}>Total tickets</div>
            <div style={{ fontSize: 28, fontWeight: 600 }}>{summary.total}</div>
          </div>
          {Object.entries(summary.byStatus).map(([k, v]) => (
            <div key={k} className="crane-card" style={{ padding: '1rem' }}>
              <div style={{ color: 'var(--crane-on-surface-variant)', fontSize: 13 }}>{k}</div>
              <div style={{ fontSize: 28, fontWeight: 600 }}>{v}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
